import { colours } from "@helpers";
import { mixpanelTrack } from "@helpers/mixpanel.helper";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";
import React from "react";
import styled from "styled-components";

const SubMenu = styled.li`
  display: grid;
  font-family: EuclidCircularABold;
  gap: 2em;
  grid-template-columns: repeat(2, max-content);
`;

const Links = styled(Link)`
  width: fit-content;
  font-size: 16px;
  gap: 0.25rem;
  height: 20px;
  width: fit-content;
  margin-left: 84vw;
  text-decoration: none;
  border-bottom: 1px solid white;
  &:hover {
    border-bottom: ${({ activeStyle }) =>
			activeStyle ? "1px solid white" : `1px solid ${colours.MIDNIGHT_BLUE}`};
  }
  text-decoration: ${({ activeStyle }) =>
		activeStyle ? "underline" : "inherit"};
`;

const DropDownContent = ({ navInfo, setIsShown }) => {
	const { asPath } = useRouter();

	const pathname = usePathname();

	return navInfo?.subNav?.map((subNavInfo) => {
		const activeStyle = subNavInfo.link === asPath;
		return (
			<SubMenu key={subNavInfo.order}>
				<Links
					onClick={() => {
						mixpanelTrack("header_hypelink_clicked", {
							cta_location: pathname,
							cta_name: subNavInfo.name,
						});
						setIsShown(false);
					}}
					href={subNavInfo.link}
					activeStyle={activeStyle}
				>
					{subNavInfo.name}
				</Links>
			</SubMenu>
		);
	});
};

export default DropDownContent;
